import { render } from "./locationmodal.vue?vue&type=template&id=72d039a8"
import script from "./locationmodal.vue?vue&type=script&lang=js"
export * from "./locationmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__